import { createContext } from "react";

export interface CheckTableType {
  identifier: string;
  page: number;
  sortingType: string;
}

interface InitialStateType {
  checkCloseTableState: CheckTableType;
  checkCloseTableSetState: React.Dispatch<React.SetStateAction<CheckTableType>>;
}

const checkCloseTableContext = createContext<InitialStateType[]>([]);

export default checkCloseTableContext;
